import "bootstrap/dist/css/bootstrap.min.css";
import { initForm } from "./template/form";

initForm();
